// extracted by mini-css-extract-plugin
export var attribution = "_bc-4";
export var authorName = "_bc-5";
export var quote = "_bc-3";
export var testimonial = "_bc-2";
export var trustedBy = "_bc-0";
export var trustedByLabel = "_bc-1";